import { useContext } from 'react';

import { Chip } from '@swyftx/aviary/atoms/Chip';
import { ChartTypeCandles } from '@swyftx/aviary/icons/charts';
import {
  Bundles,
  Coin,
  Home,
  LendingHand,
  PortfolioTransfer,
  QuickBuy,
  Rewards,
  Clock,
  TransferFunds,
  WhatsNew,
  Wallet,
  RecurringV2,
} from '@swyftx/aviary/icons/outlined';

import { Modals } from '@global-components/Modals/Modals.enum';
import { useModal } from '@global-components/Modals/useModal.hooks';

import { UIStore } from '@shared/store';

import { RewardsContext } from '@routes/Rewards/Rewards.context';

import { NavigationURLs } from 'src/lib/navigation/types';

import { MenuGroup } from './MenuGroup';
import { Item } from './item';
import { useAppSideBarAvoEvents } from '../../useAppSideBarAvoEvents';

export default function Items({ collapsed, isMobile }: { collapsed?: boolean; isMobile?: boolean }) {
  const { openModal } = useModal();
  const { unseenRewards } = useContext(RewardsContext);
  const { trackRouteNavigation } = useAppSideBarAvoEvents();
  const { setNavDrawerExpanded } = UIStore.useUIStore;

  const onOpenModal = (modal: Modals, route: NavigationURLs) => {
    trackRouteNavigation(route);
    openModal(modal);
    setNavDrawerExpanded(false);
  };

  const items: Item[] = [
    {
      title: 'Dashboard',
      icon: <Home className='h-auto w-20' />,
      path: NavigationURLs.Dashboard,
    },
    {
      title: 'Wallets',
      icon: <Wallet className='h-auto w-20' />,
      path: NavigationURLs.WalletsRoot,
    },
    {
      title: 'Asset list',
      icon: <Coin className='h-auto w-20' />,
      path: NavigationURLs.AviaryAssetsAll,
    },
    {
      title: 'Deposit & Withdraw',
      icon: <TransferFunds className='h-auto w-20 text-color-text-primary' />,
      path: NavigationURLs.DepositReceive,
      action: () => onOpenModal(Modals.DepositReceive, NavigationURLs.DepositReceive),
    },
  ];

  const invest: Item[] = [
    {
      title: 'Trade',
      icon: <ChartTypeCandles className='h-auto w-20' />,
      path: NavigationURLs.UniversalTrade,
    },
    {
      title: 'Quick buy',
      icon: <QuickBuy className='h-auto w-20' id='quickBuy' />,
      path: NavigationURLs.QuickBuy,
    },
    {
      title: 'Auto invest',
      icon: <RecurringV2 className='h-auto w-20' />,
      path: NavigationURLs.AutoInvest,
    },
    {
      title: 'Bundles',
      icon: <Bundles className='h-auto w-20' />,
      path: NavigationURLs.Bundles,
    },
  ];

  const credit: Item[] = [
    {
      title: 'Loans',
      icon: <LendingHand className='h-auto w-20' />,
      path: NavigationURLs.Loans,
    },
  ];

  const account: Item[] = [
    {
      title: 'Transactions',
      icon: <Clock className='h-auto w-20' />,
      path: NavigationURLs.TransactionsRoot,
    },
  ];

  if (isMobile) {
    account.push(
      {
        title: 'Portfolio Transfer',
        icon: <PortfolioTransfer className='h-auto w-20' />,
        path: NavigationURLs.PortfolioTransfer,
      },
      {
        title: 'Rewards',
        icon: <Rewards className='h-auto w-20' />,
        path: NavigationURLs.RewardsRoot,
        endAdornment:
          unseenRewards > 0 ? (
            <Chip variant='default' leadingIcon={<WhatsNew className='text-color-text-inverse' />}>
              {String(unseenRewards)}
            </Chip>
          ) : (
            <></>
          ),
      },
    );
  }

  return (
    <>
      <MenuGroup collapsed={collapsed} items={items} />
      <MenuGroup collapsed={collapsed} items={invest} title='INVEST' />
      <MenuGroup collapsed={collapsed} items={credit} title='CREDIT' />
      <MenuGroup collapsed={collapsed} items={account} title='ACCOUNT' />
    </>
  );
}
